import type { Domain } from '@/config/domain/type';

export const diyNewZealand: Domain = {
    domain: import.meta.env.VITE_DIY_NZ_DOMAIN,
    website: 'https://www.diytm.co.nz',
    shortCode: 'diy-nz',
    markSource: 'DIYV2-NZ',
    title: 'Apply for your NZ trademark',
    name: 'DIY Trademarks',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your NZ trademark by entering your trademark or logo.',
    logo: '/img/DIY-Logo.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/trademark-cost' },
        { label: 'FAQ', url: '/faq' },
        { label: 'About', url: '/about-us' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-conditions' },
        { label: 'Contact Us', url: '/contact' },
    ],
    bannerImageUrl: '/img/DIY-Banner-NZ-XL.png',
    termOfUseUrl: '/terms-conditions',
    gtmId: 'GTM-57R6JNG9',
};
